import { render } from "./PageAnnouncement.vue?vue&type=template&id=4b398dc8"
import script from "./PageAnnouncement.vue?vue&type=script&lang=js"
export * from "./PageAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__